function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.016 3.072c-1.16 3.853-3.415 5.67-4.832 6.184v12.37h11.402c1.856 0 2.706-1.805 2.9-2.706.257-1.224.927-4.446 1.546-7.538.618-3.092-1.675-3.478-2.9-3.285l-6.184.58c.58-.58 1.569-2.396 2.32-4.639.966-2.886-3.151-4.625-4.252-.966zM1 7.53h6.184v15.461H1z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgThumbUpWhite = function SvgThumbUpWhite(props) {
  return React.createElement("svg", _extends({
    width: 88,
    height: 24,
    viewBox: "-30 0 88 24",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='88' height='24' viewBox='-30 0 88 24' fill='none' xmlns='http://www.w3.org/2000/svg' %3E %3Cpath d='M12.0156 3.07211C10.8561 6.92484 8.60134 8.74112 7.18408 9.25648V21.6252H18.5865C20.4418 21.6252 21.2922 19.8214 21.4855 18.9196C21.7431 17.6956 22.4131 14.4745 23.0316 11.3823C23.65 8.29015 21.3566 7.90363 20.1326 8.09689L13.9482 8.67668C14.528 8.0969 15.5166 6.28114 16.2674 4.03841C17.2337 1.15203 13.117 -0.587333 12.0156 3.07211Z' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='7.52979' width='6.18438' height='15.461' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E";
export { SvgThumbUpWhite as ReactComponent };